import { useState, useEffect } from "react";

export const useScrollDirection = () => {
  const [scrollDir, setScrollDir] = useState(false); //false means scroll UP
  // console.log(".........useScrollDirection called..........dependency: ");
  useEffect(() => {
    const threshold = 0;
    let lastScrollY = window.pageYOffset;
    let ticking = false;

    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;

      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      setScrollDir(scrollY > lastScrollY);

      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir); //requestAnimationFrame to make sure that we are calculating the new offset after the page got rendered completely after scroll
        ticking = true; //ticking flag will make sure we are just running our event listener callback once in each requestAnimationFrame.
      }
    };

    window.addEventListener("scroll", onScroll);
    // console.log("...", scrollDir);

    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollDir]);

  return scrollDir;
};
